import ajax from '../utils/ajax'

const ERROR_REPORT_LIMIT = 10
let errorReportCount = 0

export default {
  send (type, data = {}) {
    if (typeof type !== 'string') data = type || {}

    Object.assign(data, {
      appName: 'd_home',
      appVersion: window.PCLN_BOOTSTRAP_DATA.appVersion,
      rebuild: true
    })

    const URL = '/pws/v0/fly/tag/error/jsError'

    if (type === 'error') {
      errorReportCount++

      if (errorReportCount === ERROR_REPORT_LIMIT) return
    }

    ajax({
      url: URL,
      type: 'GET',
      dataType: 'json',
      data
    })
  }
}
